// Vendor imports
const _ = require('lodash')
const Promise = require('bluebird')
// Client V1 imports
const { send: ajax } = require('client/lib/request')
const airbrake = require('client/lib/airbrake')
// Common Client V2 imports
const articleProfileModalActions = require('client-v2/common/containers/article-profile/state/modal-actions')
const {
  isArticleModel,
  getCachedReportedUrlIds
} = require('client-v2/common/models/article/utils')
// Sibling imports
const { defaultFeedSelectors } = require('./selectors')

let lastFeedInstanceId = 0

module.exports = {
  createFeedActions,
  defaultFeedActions: createFeedActions(defaultFeedSelectors)
}

function createFeedActions(feedSelectors) {
  // Disambiguate against other feed instances
  const feedInstanceId = ++lastFeedInstanceId

  // Instance action types

  const MORE_LOADING = 'FEED_MORE_LOADING_' + feedInstanceId
  const MORE_LOADED = 'FEED_MORE_LOADED_' + feedInstanceId

  // Instance action dispatchers

  function loadMore() {
    return function (dispatch, getState) {
      loadMorePromise(dispatch, getState)
    }
  }

  function showArticleProfileModal(options = {}) {
    const urlId = options.article && options.article['url_id']
    return function (dispatch, getState) {
      const state = getState()
      const articleItems = feedSelectors.getItems(state).filter(isArticleModel)
      dispatch(articleProfileModalActions.show({
        initialIndex: articleItems.findIndex(obj => obj.id === urlId),
        items: articleItems,
        meta: feedSelectors.getMeta(state),
        nextPageCallback
      }))
      function nextPageCallback() {
        return loadMorePromise(dispatch, getState)
        .then(({ items, meta }) => ({
          items: items.filter(isArticleModel),
          meta
        }))
      }
    }
  }

  // Instance action creators

  function loading() {
    return {
      type: MORE_LOADING
    }
  }

  function loaded({ items, meta }) {
    return {
      type: MORE_LOADED,
      payload: { items, meta }
    }
  }

  // Instance action helpers

  function loadMorePromise(dispatch, getState) {
    const state = getState()
    if (!feedSelectors.getIsNextPageAvailable(state)) {
      return Promise.reject(Error('No more content available'))
    }
    dispatch(loading())
    return ajax({
      url: feedSelectors.getNextPageUrl(state),
      method: 'get'
    })
    .then(normalizeMoreResponse)
    .then(response => {
      dispatch(loaded(response))
      return response
    })
    .catch(err => {
      airbrake.notify(err)
      throw err
    })
  }

  // Instance exports

  return {
    MORE_LOADING,
    MORE_LOADED,
    loadMore,
    showArticleProfileModal
  }
}

// Instance-agnostic action helpers

function normalizeMoreResponse(response) {
  let { meta } = response
  // Handle the inconsistent shape of the user API stream
  // See app/controllers/api/user-controller methods
  let items = (
    response.items ||
    response.mixes ||
    response.followingMixes ||
    response.friends ||
    response.followers ||
    []
  )
  // Reject reported URLs that have been locally cached
  const reportedUrlIds = getCachedReportedUrlIds()
  if (reportedUrlIds.length) {
    items = _.reject(items, item => (
      isArticleModel(item) &&
      reportedUrlIds.includes(item['url_id'])
    ))
  }
  // Handle the blindly-optimistic server-side pagination logic
  if (!items.length) {
    meta = { nextUrl: null }
  }
  return { items, meta }
}
